module.exports = __webpack_public_path__ + "f1e8476e7a9a505f6a95f7e0ef20784a.svg";